import { Link } from '@mui/material'
import { formatCurrency, formatDate } from '../../../../../utils/formatter'
import clsx from 'clsx'
import { Text } from '../../../../ui'
import iconoEnlace from '../../../../../../assets/iconos/iconEnlace.png'
import isologo_SII from '../../../../../../assets/isologo_SII.png'
import iconVinculos from '../../../../../../assets/iconosCardInformes/informe_9.png'
import { useMemo, useState } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import ModalConciliarVinculacion from '../../Administracion/Vinculaciones/modalDialogEditVinculacion/ModalConciliarVinculacion'
import translations from '../../../../ui/traslation/traslationAdministracion.json'

const columns = [
  { col: '', field: null },
  { key: 'fecha', label: 'Fecha' },
  { key: 'tipo', label: 'Tipo de vinculación' },
  { key: 'contraparte', label: 'Contraparte' },
  { key: 'clasificacion', label: 'Clasificación' },
  { key: 'monto', label: 'Monto' },
  { key: 'status', label: 'Status' },
  { key: 'acciones', label: 'Acciones' },
]

const styles = {
    table: 'w-full min-w-[980px] table-auto text-[0.65rem] sm:text-[0.725rem] border-collapse leading-tight font-sans',
    thead: 'sticky top-[-2] z-10 bg-white',
    th: 'py-2 px-1 sm:px-2 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.55rem] sm:text-[0.6rem] font-bold text-gray-500',
    tr: 'hover:bg-gray-50 transition-colors',
    td: 'py-2 px-1 sm:px-2 w-auto max-w-[200px] text-center break-words align-middle',
    smallCol: 'w-auto max-w-[70px] sm:max-w-[80px]',
    wideCol: 'w-auto max-w-[220px] sm:max-w-[300px]',
    boldText: 'font-bold text-[0.6rem] sm:text-[0.65rem]',
    text: 'text-[0.6rem] sm:text-[0.705rem] text-gray-400 font-medium',
    dateHeader: 'bg-gray-50/80 backdrop-blur-sm border-y border-gray-200/50 py-2 px-4 text-left font-bold text-primary flex items-center gap-2 cursor-pointer hover:bg-gray-100 transition-colors group font-sans'
  }

const ORIGENES_F29_AGRUPABLES = [39, 48]

const getNombreTipoVinculacion = row => {
  const origenTabla = Number(row?.origenTabla)
  if (origenTabla === 39) return 'Formulario 29'
  if (origenTabla === 48) return 'IVA Postergado'
  return row?.nombreFolio || 'Formulario 29'
}

const normalizarIdentificador = value => {
  if (value == null || value === '') return ''
  const numero = Number(value)
  return Number.isFinite(numero) ? String(numero) : String(value).trim().toLowerCase()
}

const agruparMovimientosF29 = rows => {
  const grupos = new Map()

  rows
    .filter(row => [37, ...ORIGENES_F29_AGRUPABLES].includes(Number(row.origenTabla)))
    .forEach((row, index) => {
      const origenTabla = Number(row.origenTabla)
      const puedeAgruparse = ORIGENES_F29_AGRUPABLES.includes(origenTabla)
      const idOrigen = normalizarIdentificador(
        row.idOrigen ?? row.id_origen ?? row.originId ?? row.idOrigin
      )
      const comprobante = normalizarIdentificador(
        row.comprobante ?? row.codigoCuenta ?? row.nombreCuenta
      )
      const folio = normalizarIdentificador(row.numeroFolio ?? row.folio)
      const fecha = normalizarIdentificador(row.fecha)
      const tieneIdentificadores = Boolean(idOrigen && comprobante)
      const identificadorComun = tieneIdentificadores
        ? `${idOrigen}-${comprobante}`
        : `${folio}-${comprobante}-${fecha}`
      const key = puedeAgruparse && tieneIdentificadores
        ? `f29-${identificadorComun}`
        : puedeAgruparse && folio && comprobante
          ? `f29-fallback-${identificadorComun}`
        : `individual-${row.id ?? index}`

      if (!grupos.has(key)) grupos.set(key, [])
      grupos.get(key).push(row)
    })

  return Array.from(grupos, ([key, movimientos]) => ({
    key,
    movimientos: movimientos.sort((a, b) => {
      const orden = { 39: 0, 48: 1 }
      return (orden[Number(a.origenTabla)] ?? 2) - (orden[Number(b.origenTabla)] ?? 2)
    })
  }))
}



const ResumenVinculosTable = ({ rows = [], isLoading,setSwitchGetData, onOpenComprobante = () => {} }) => {
  const [openEdit, setOpenEdit] = useState(false)
  const [dataModal, setDataModal] = useState({
    idLibro: '',
    fVenc: '',
    folio: '',
    status: '',
    folioCredito: '',
    nombreOrigen: ''
  })

  const handleClickEdit = (row) => {
    const origenTabla = Number(row?.origenTabla)
    const esIvaPostergado = origenTabla === 48
    const idLibro = esIvaPostergado
      ? row?.idPrevired ?? row?.id
      : origenTabla === 39
        ? row?.idLiquido ?? row?.id
        : row?.id
    const montoTotal = esIvaPostergado
      ? row?.totalPrevired ?? row?.montoTotal
      : origenTabla === 39
        ? row?.totalCargo ?? row?.montoTotal
        : row?.montoTotal
    const status = esIvaPostergado ? row?.statusPrevired ?? row?.status : row?.status
    const modalRow = { ...row, id: idLibro, montoTotal, status }
    const egresos = [24, 25];
    const ingresos = [26, 27];
    let type = 'vinculos';
    if (egresos.includes(row.origenTabla)) {
        type = 'egreso';
    } else if (ingresos.includes(row.origenTabla)) {
        type = 'ingreso';
    }
    setDataModal({ 
        idLibro,
        fVenc: row.fechaVencimiento, 
        folio: row.numeroFolio,
        status,
        type,
        folioCredito: row.folioCredito,
        nombreOrigen: row.nombreOrigen,
        origenTabla: row.origenTabla,
        row: modalRow
    });
    setOpenEdit(true);
  };

  const gruposF29 = useMemo(() => agruparMovimientosF29(rows), [rows])
  
  const normalizeStatus = status =>
      String(status || '')
        .toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/_/g, ' ')
        .trim()
  
    const getStatusKey = status => {
      const normalized = normalizeStatus(status)
      if (!normalized) return 'UNKNOWN'
      if (normalized.includes('PARCIAL')) {
        if (normalized.includes('PAG')) return 'PARCIAL_PAGADO'
        if (normalized.includes('COBR')) return 'PARCIAL_COBRADO'
      }
      if (normalized.includes('POR PAG')) return 'POR_PAGAR'
      if (normalized.includes('POR COB')) return 'POR_COBRAR'
      if (normalized.includes('PAGADO')) return 'PAGADO'
      if (normalized.includes('COBRADO')) return 'COBRADO'
      if (normalized.includes('CONCILIADO')) return 'CONCILIADO'
      if (normalized.includes('CERO')) return '-'
      return normalized
    }
  
    const getStatusLabel = status => {
      const key = getStatusKey(status)
      if (key === 'PARCIAL_PAGADO') return 'PARCIALMENTE PAGADO'
      if (key === 'PARCIAL_COBRADO') return 'PARCIALMENTE COBRADO'
      if (key === 'POR_PAGAR') return 'POR PAGAR'
      if (key === 'POR_COBRAR') return 'POR COBRAR'
      if (key === 'PAGADO') return 'PAGADO'
      if (key === 'COBRADO') return 'COBRADO'
      if (key === 'CONCILIADO') return 'CONCILIADO'
      if (key === 'CERO') return '-'
      return key === 'UNKNOWN' ? '—' : key
    }
  
    const statusBadgeClass = status => {
      const key = getStatusKey(status)
      const isPending = key === 'POR_PAGAR' || key === 'POR_COBRAR'
      const isPaid = key === 'PAGADO' || key === 'COBRADO' || key === 'CONCILIADO'
      const isPartial = key === 'PARCIAL_PAGADO' || key === 'PARCIAL_COBRADO'
      return clsx(
        'inline-flex items-center justify-center rounded-full px-3 py-1 text-[0.55rem] sm:text-[0.6rem] font-semibold uppercase tracking-wider leading-tight',
        {
          'text-danger bg-danger/10': isPending,
          'text-success bg-success/10': isPaid,
          'text-amber-700 bg-amber-100': isPartial,
          'text-muted bg-border/40': !isPending && !isPaid && !isPartial
        }
      )
    }

  return (
    <div className=' rounded-2xl bg-white/95 flex flex-col overflow-hidden font-sans'>
      <div className=' px-4 py-2 flex items-center justify-between'>
        <p className='text-[11px] font-semibold uppercase tracking-[0.2em] text-gray-400'></p>
        {isLoading && <span className='text-[11px] text-gray-500'>Cargando…</span>}
      </div>
      <div className='flex-1 px-3 py-3 overflow-auto' style={{ maxHeight: '520px' }}>
        {(!rows || rows.length === 0) && !isLoading ? (
          <div className="flex flex-col items-center justify-center h-full min-h-[450px]">
            <SearchIcon fontSize="large" className="mb-4 text-gray-400" />
            <Text>{translations.tableAction.noF29}</Text>
          </div>
        ) : (
          <div className="relative rounded-xl bg-white shadow-sm font-sans">
          <table className={styles.table}>
            <thead className={styles.thead}>
              <tr>
                {columns.map(col => (
                  <th key={col.key} className={clsx(styles.th, styles.boldText)}>
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
             {gruposF29.map(grupo =>
              grupo.movimientos.map((row, idx) => {
                const rowSpan = grupo.movimientos.length
                const esPrimeraFila = idx === 0
                const esGrupoDividido = rowSpan > 1
                const esUltimaFila = idx === rowSpan - 1
                const effectiveStatus =
                  row.reconciliationStatus ||
                  row.status ||
                  'POR PAGAR'

                const isReconciled =
                  row.isReconciled === true ||
                  getStatusKey(effectiveStatus) === 'PAGADO' ||
                  getStatusKey(effectiveStatus) === 'COBRADO' ||
                  getStatusKey(effectiveStatus) === 'CONCILIADO'

                const actionEnabled =
                  row.actionEnabled === true ||
                  isReconciled

                return (
                <tr
                  key={row.id || `${grupo.key}-${idx}`}
                  className={clsx(styles.tr, { 'border-b border-gray-100': esUltimaFila })}
                >
                  {esPrimeraFila && <td rowSpan={rowSpan} className={styles.td}>
                    {row.nombreOrigen === 'manual' ? (
                      <img src={iconVinculos} alt="manual" className="w-9 h-9" />
                      ) : row.nombreOrigen === 'sii' ? (
                      <img src={isologo_SII} alt="sii" className="w-5 h-5" />
                      ) : (
                      <img src={iconVinculos} alt="default" className="w-9 h-9" />
                      )}
                  </td>}
                  {esPrimeraFila && <td rowSpan={rowSpan} className={styles.td}><Text className={styles.boldText}>{row.fecha ? formatDate(row.fecha) : '-'}</Text></td>}
                  {esPrimeraFila && esGrupoDividido ? (
                    <td rowSpan={rowSpan} className={styles.td}>
                      <div
                        className='relative grid h-full min-h-[96px] items-center'
                        style={{ gridTemplateRows: `repeat(${rowSpan}, minmax(0, 1fr))` }}
                      >
                        {grupo.movimientos.map((movimiento, movimientoIdx) => (
                          <div
                            key={movimiento.id || movimiento.origenTabla}
                            className='flex h-full items-center justify-center'
                            style={{ gridRow: movimientoIdx + 1 }}
                          >
                            <Text className={styles.boldText}>
                              {getNombreTipoVinculacion(movimiento)}
                            </Text>
                          </div>
                        ))}
                        <Text className={`${styles.text} pointer-events-none absolute left-0 right-0 top-1/2 -translate-y-1/2`}>
                          {row.numeroFolio ? `Folio ${row.numeroFolio}` : ''}
                        </Text>
                      </div>
                    </td>
                  ) : !esGrupoDividido ? (
                    <td className={styles.td}>
                      <div className='flex flex-col'>
                        <Text className={styles.boldText}>{getNombreTipoVinculacion(row)}</Text>
                        <Text className={styles.text}>{row.numeroFolio ? `Folio ${row.numeroFolio}` : ''}</Text>
                      </div>
                    </td>
                  ) : null}
                  {esPrimeraFila && <td rowSpan={rowSpan} className={styles.td}>
                    <div className='flex flex-col'>
                      <Text className={styles.boldText}>SII</Text>
                    </div>
                  </td>}
                  {esPrimeraFila && <td rowSpan={rowSpan} className={styles.td}>
                  <Text className={styles.text}>
                    <Link
                      type='button'
                      onClick={() => onOpenComprobante(row)}
                      className={styles.text}
                      style={{ cursor: 'pointer' }}
                    >
                      {row.comprobante || row.codigoCuenta || row.nombreCuenta || '-'}
                    </Link>
                    <Text className={styles.text}>@{row.usuarioClasificador || 'TryLuca'}</Text>
                  </Text>
                  </td>}
                  <td className={styles.td}>
                    <Text className={styles.boldText}>
                      {row.montoTotal === 0
                        ? 'Sin pago'
                        : typeof row.montoTotal === 'number'
                          ? formatCurrency(row.montoTotal)
                          : row.montoTotal || '-'}
                    </Text>
                  </td>
                  <td className={styles.td}>
                    <Text className={statusBadgeClass(effectiveStatus)}>
                      {getStatusLabel(effectiveStatus)}
                    </Text>
                  </td>
                  <td>
                    {!(row.montoTotal === 0 && row.status === 'CERO') && (
                      <div className='flex h-full items-center justify-center space-x-3'>
                        <div className='flex flex-col text-xs text-gray-500 items-center justify-center hover:cursor-pointer'>
                          <div
                            className={clsx(
                              'flex text-slate-400 shadow-full-xs mt-1 rounded-full items-center justify-center w-7 h-7 hover:bg-slate-100/50 transition-colors duration-150',
                              {
                                'bg-accent2 text-white': actionEnabled,
                                'bg-[#fff]': !actionEnabled,
                              }
                            )}
                            onClick={() =>
                              handleClickEdit({
                                ...row,
                                status: effectiveStatus
                              })
                            }
                          >
                            <img
                              src={iconoEnlace}
                              alt="icono enlace"
                              className={clsx('w-5 h-5 transition-all duration-300', {
                                'brightness-200': actionEnabled,
                              })}
                            />
                          </div>
                          <Text className='mt-2'>
                            {isReconciled ? 'Conciliado' : 'Conciliar'}
                          </Text>
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
              )}))}
            </tbody>
          </table>
          </div>
        )}
      </div>
      {openEdit && (
        <ModalConciliarVinculacion
          open={openEdit}
          setOpen={setOpenEdit}
          idLibro={dataModal.idLibro}
          fVenc={dataModal.fVenc}
          folio={dataModal.folio}
          type={dataModal.type}
          status={dataModal.status}
          folioCredito={dataModal.folioCredito}
          nombreOrigen={dataModal.nombreOrigen}
          origenTabla={dataModal.origenTabla}
          row={dataModal.row}
          setSwitchGetData={setSwitchGetData}
        />
      )}
    </div>
  )
}

export default ResumenVinculosTable
